import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'proplus',
    component: () => import(/* webpackChunkName: "authorization" */ '../views/Proplus.vue')
  },

  {
    path: '/requestdemo/',
    name: 'requestdemo',
    component: () => import(/* webpackChunkName: "authorization" */ '../views/Requestdemo.vue')
  },
 
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  scrollBehavior (to, from, savedPosition) {

    console.log('to.hash', to)

    if (to.hash) {

     

      return {
        selector: to.hash
      }
    }
  }
})

export default router
